export default __webpack_public_path__ + "static/media/GalanoGrotesque.e1d8f16c.woff2";